/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_External_SoundsInputs */



/**
* | output |
* | --- |
* | "Use External Sounds" |
*
* @param {Leveling_Perm_Use_External_SoundsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_external_sounds = /** @type {((inputs?: Leveling_Perm_Use_External_SoundsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_External_SoundsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать внешние звуки")
	return /** @type {LocalizedString} */ ("Use External Sounds")
});